import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center h-full justify-center p-8 sm:p-2" }
const _hoisted_2 = { class: "flex flex-col gap-8 justify-center items-center text-center pb-[20%] sm:pb-[10%]" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl sm:text-3xl font-bold" }, "¡Registro exitoso!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1 text-md sm:text-2xl font-light" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Tu cuenta ha sido creada correctamente."),
  /*#__PURE__*/_createElementVNode("p", null, " Revisa tu correo para ver tus credenciales y descargar la aplicación. ")
], -1)

import success from "@/assets/success.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentRegisterSuccess',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "w-[50%] sm:w-auto m-auto",
          src: _unref(success),
          alt: "success-image"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _hoisted_6
    ])
  ]))
}
}

})